<template>
  <div class="mantras" :class="resource">
    <div class="uyh-back">
      <router-link to="/pick-a-mantra">
        <svg svg-inline="" class="uyh-back-arrow js-back" role="presentation" focusable="false" width="19" height="30" viewBox="0 0 19 30" xmlns="http://www.w3.org/2000/svg"><path d="M15.882 30L0 15 15.882 0l3.065 2.896L6.131 15l12.816 12.103z" fill="#21362C" fill-rule="evenodd"/></svg><span>{{ $t('navigation.back') }}</span>
      </router-link>
    </div>
    <StepInfo :step="'2'" :totalSteps="'3'" :message="$t('step_nav.step_1')"/>

    <MantraIndex @loader-active="$emit('loader-active')"
                 @loader-inactive="$emit('loader-inactive')"
                 @show-gallery-upload="$emit('show-gallery-upload')"
                 @show-take-picture="$emit('show-take-picture')"/>
  </div>
</template>

<script>
  import StepInfo from '@/components/Global_StepInfo.vue'
  import MantraIndex from '@/components/Mantra_Index.vue'

  export default {
    name: 'TextMantraFormat',
    data: function() {
      return {
        resource: ''
      }
    },
    components: {
      StepInfo,
      MantraIndex
    },
    beforeMount: function() {
      this.resource = this.$route.params.resource;
    }
  }
</script>

<style lang="scss" scoped>
  .responsivesite #wrapper #uyh-app,
  #uyh-app {
    .mantra-format {
      .mantras {
        &.image {
          background-color: #fceff3;
        }
      }
    }
  }
</style>
